import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { ChatImage } from './types';

interface ChatImageGalleryProps {
  images: ChatImage[];
  alt: string;
  thumbnailClassName?: string;
}

export function ChatImageGallery({
  images,
  alt,
  thumbnailClassName = 'h-20 w-20 object-cover transition-transform group-hover:scale-[1.02]',
}: ChatImageGalleryProps) {
  const [expandedImage, setExpandedImage] = useState<ChatImage | null>(null);

  if (images.length === 0) return null;

  return (
    <>
      <div className="mt-2 flex flex-wrap gap-2">
        {images.map((image, index) => (
          <button
            key={`${image.mediaType}-${index}`}
            type="button"
            onClick={() => setExpandedImage(image)}
            className="group overflow-hidden rounded-lg border bg-background transition-colors hover:border-primary/50"
          >
            <img
              src={`data:${image.mediaType};base64,${image.data}`}
              alt={alt}
              className={thumbnailClassName}
            />
          </button>
        ))}
      </div>

      <Dialog
        open={Boolean(expandedImage)}
        onOpenChange={(open) => !open && setExpandedImage(null)}
      >
        <DialogContent className="w-[calc(100vw-2rem)] max-w-5xl p-3 sm:p-4">
          <DialogHeader className="sr-only">
            <DialogTitle>Evidence image</DialogTitle>
            <DialogDescription>Expanded chat evidence image.</DialogDescription>
          </DialogHeader>
          {expandedImage ? (
            <div className="flex max-h-[85vh] items-center justify-center overflow-auto rounded-md bg-muted/30">
              <img
                src={`data:${expandedImage.mediaType};base64,${expandedImage.data}`}
                alt={alt}
                className="max-h-[80vh] w-auto max-w-full rounded-md object-contain"
              />
            </div>
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
